import { MSCalendar } from "../..";
import styles from "../styles.css";
import { IEvent, IWeeklyState } from "@lib/store/src/calendar";
import { UiFloatPopover } from "../../../common/popover";
import { WeekModal } from "./week";
import { getEditEventWeekTemplate } from "./edit-event-week.templates";
import moment from "moment";
import { EventObject } from "@toast-ui/calendar/types/types/events";
import { popupEvent } from "../modal.templates";
import i18next from "i18next";

/**
 * Редактирование события (расширение WeekModal class)
 * @class EditEventWeekModal
 * @extends WeekModal
 * @classdesc EditEventWeekModal
 * */
export class EditEventWeekModal extends WeekModal {
  selectedDay: number = null; // index дня для редактирования
  event: IEvent; //
  weeklySchedule: IWeeklyState; // Копия стейта для обновления события по ссылке

  constructor(rootID: string, root: MSCalendar) {
    super(rootID, root);
    super.init(getEditEventWeekTemplate(), styles);

    this.validateForm = () => {
      this.isValidForm([this.selectedDay]);
    }
  }

  /**
   * Инициализация обработчиков событий
   */
  onStartup() {
    const modal = this.popup.modalComponent;

    modal.addEventListener("click", (e) => {
      const target = e.target as HTMLElement;

      // Обработка кнопки "Сохранить"
      if (target.closest("#submit")) {
        this.save();
      }

      // Обработка кнопки "Сбросить"
      if (target.closest("#reset")) {
        this.close();
      }
    });

    this.bodyEvents?.addEventListener("click", (e) => this.onClickEvent(e));
  }

  /**
   * Обработчик кнопки сохранения нового расписания
   * */
  save() {
    if (!this.isValidForm([this.selectedDay])) return;

    this.store.onChange("weeklySchedule", this.weeklySchedule);

    this.root.saveSchedule();

    this.close();
  }

  /**
   * Показ попапа подтверждения удаления
   * @param {MouseEvent} e MouseEvent
   * @param {HTMLElement} row Строка события
   *
   */
  showDeleteConfirmationPopup(e: MouseEvent, row: HTMLElement) {
    setTimeout(() => {
      const popover = new UiFloatPopover(
        popupEvent({
          title: i18next.t($ => $.scheduleBacnet.deletion),
          desc: i18next.t($ => $.scheduleBacnet.eventDeleteConfirmation),
        }),
        {
          x: e.clientX,
          y: e.clientY,
        }
      );

      popover.root.querySelector("#primary")?.addEventListener("click", () => {
        const currentDay = this.weeklySchedule[this.selectedDay];
        const updatedDay = currentDay?.filter(
          (event: IEvent) => event.id !== row.dataset.eventId
        );

        this.weeklySchedule[this.selectedDay] = updatedDay;

        this.save();
        row.remove();
        popover.destroy();
      });

      popover.root
        .querySelector("#secondary")
        ?.addEventListener("click", () => popover.destroy());
    }, 0);
  }

  /**
   * Установка выбранного дня в radio-кнопке по умолчанию
   * @param {number} currentDay Index дня недели (0-6)
   */
  initCurrentWeekDay(currentDay: number) {
    const radioButtons = this.popup.modalComponent.querySelectorAll(
      "#week-day-edit fw-radio"
    );
    this.selectedDay = (currentDay + 6) % 7; // Сдвигаем индекс, чтобы 0 был понедельником

    Array.from(radioButtons).forEach((el, i) => {
      el.checked = i === this.selectedDay;
    });
  }

  /**
   * Отображение события для редактирования
   */
  renderEvent() {
    if (!this.event) return;
    this.addEventTime(this.event);
  }

  /**
   * Получение данных о событии
   */
  changeEventData(calendarEvent: EventObject) {
    if (!calendarEvent)
      throw new Error("Ошибка редактирования: не найдено событие");
    this.popup.modalComponent.open();

    // Сохраняем копию стейта в котором по ссылке измением событие
    this.weeklySchedule = JSON.parse(
      JSON.stringify(this.root.store.weeklySchedule)
    );

    const timeEvent = moment(calendarEvent?.start?.d?.d);
    this.initCurrentWeekDay(timeEvent.day()); // Установка дня события

    this.event = this.weeklySchedule[this.selectedDay]?.find(
      (event: IEvent) => event.id === calendarEvent?.id
    );

    this.renderEvent();
  }

  /**
   * Открытие модального окна
   */
  open(params?: any) {
    this.popup.modalComponent.open();

    super.resetForm(); // Сброс формы
    this.popup.uiModal.resetSize();

    this.changeEventData(params?.event);
    this.validateForm();
  }
}
